import React from 'react';
import { Row, Card } from 'reactstrap';
import { TotalRegister } from 'components/TotalRegister';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { v4 as uuid } from 'uuid';

/**
 * Renderiza uma tabela do boostrap a partir de dados e colunas passadas pelo elemento-pai.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {Array<Object>} props.data - Dados dos relatórios a serem exibidos.
 * @param {number} props.totalRecords - Número total de registros.
 * @param {boolean} [props.showTotalRecords=true] - Se deve ou não ser exibido o total de registros.
 * @param {Array<import('react-bootstrap-table-next'.ColumnDescription)>} props.columns - Definição das colunas da tabela.
 * @param {'left'|'center'|'right'} [props.headerTextAlign='left'] - Alinhamento do texto no cabeçalho das colunas.
 * @param {'left'|'center'|'right'} [props.cellTextAlign='left'] - Alinhamento do texto nas células da tabela.
 * @returns {JSX.Element} Componente de tabela de relatórios.
 *
 * @example
 * const Exemplo = () => {
 *   const reportData = [
 *     { id: 1, name: 'Relatório 1', date: '2023-01-01' },
 *     { id: 2, name: 'Relatório 2', date: '2023-01-02' },
 *   ];
 *
 *   const columns = [
 *     {
 *       dataField: 'id',
 *       text: 'ID',
 *       sort: true,
 *     },
 *     {
 *       dataField: 'name',
 *       text: 'Nome',
 *       sort: true,
 *     },
 *     {
 *       dataField: 'date',
 *       text: 'Data',
 *       sort: true,
 *     },
 *   ];
 *
 *   return (
 *     <FlexBootstrapTable
 *       data={reportData}
 *       totalRecords={10000}
 *       columns={columns}
 *       headerTextAlign="center"
 *     />
 *   );
 * };
 */
export function FlexBootstrapTable({
  data,
  totalRecords,
  columns,
  showTotalRecords = true,
  headerTextAlign = 'left',
  cellTextAlign
}) {
  const styledColumns = columns.map((column) => ({
    ...column,
    headerAlign: headerTextAlign,
    align: cellTextAlign
  }));

  return (
    <>
      <Row>
        <div className="col">
          <div className="card-wrapper">
            {showTotalRecords && totalRecords >= 0 && (
              <TotalRegister totalRegister={totalRecords} />
            )}
            <Card style={{ boxShadow: 'none' }}>
              <ToolkitProvider
                data={data.map((row) => {
                  row.react_key = uuid();
                  return row;
                })}
                keyField="react_key"
                columns={styledColumns}
              >
                {(toolkitProps) => (
                  <div className="py-4 table-responsive">
                    <BootstrapTable
                      {...toolkitProps.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      classes="align-items-center"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </div>
        </div>
      </Row>
    </>
  );
}
